import vue from "vue";

export default {
    SET_TITLE: (state, title) => {
        state.title = title;
    },
    SET_SECTION: (state, section) => {
        state.section = section;
    },
    SET_UNITS: (state, units) => {
        state.units = units;
    },
    SET_UNITS_FOR_CURRENT_USER: (state, units) => {
        state.unitsForCurrentUser = units;
    },
    SET_UNIT: (state, unit) => {
        state.unit = unit;
    },
    SET_STATUS: (state, status) => {
        state.status = status;
    },
    SET_UNIT_TO_EDIT: (state, unitToEdit) => {
        state.unitToEdit = unitToEdit;
    },
    SET_TOTAL: (state, total) =>{
        state.total = total
    },
    SET_MONITORING_DOCTORS: (state, doctors) =>{
        state.monitoringDoctors = doctors
    },
}